var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import './Select.scss';
import Select from 'react-select';
import Loader from '@/components/Loader/Loader';
var SelectStatistics = function (_a) {
    var data = _a.data, setItem = _a.setItem, isLoading = _a.isLoading;
    var BodyTextOne = useCallback(function (_a) {
        var title = _a.title, size = _a.size;
        return (_jsx("div", __assign({ style: size ? { fontSize: size } : {}, className: "BodyTextOne" }, { children: title })));
    }, []);
    var options = data.map(function (item) {
        return ({
            value: item,
            label: _jsx(BodyTextOne, { title: item }),
            searchLabel: item,
            restaurant: item,
        });
    });
    var handleChange = function (selected) {
        setItem(selected.restaurant);
    };
    if (isLoading)
        return (_jsx("div", __assign({ style: { marginBottom: '20px' } }, { children: _jsx(Loader, { width: "24px", height: "24px" }) })));
    if (data.length === 0) {
        return _jsx("div", __assign({ className: "empty-list" }, { children: "\u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0443\u0441\u0442" }));
    }
    return (_jsx(Select, { isSearchable: true, getOptionLabel: function (e) { return e.searchLabel; }, filterOption: function (option, inputValue) {
            return option.data.searchLabel.toLowerCase().includes(inputValue.toLowerCase());
        }, styles: {
            control: function (base, state) {
                return (__assign(__assign({}, base), { borderRadius: '8px', borderBottomRightRadius: state.menuIsOpen ? 0 : '8px', borderBottomLeftRadius: state.menuIsOpen ? 0 : '8px', backgroundColor: 'white', border: '1px solid #E3E3E3', boxShadow: state.isFocused ? '0 0 0 1px #E3E3E3' : 'none', '&:hover': {
                        border: '1px solid #E3E3E3',
                    } }));
            },
            dropdownIndicator: function (base, state) { return (__assign(__assign({}, base), { color: '#000000', transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease', paddingLeft: '0px', paddingRight: '0px', marginLeft: '0px', marginRight: '12px' })); },
            indicatorSeparator: function (base) { return (__assign(__assign({}, base), { display: 'none' })); },
            option: function (base, state) {
                return (__assign(__assign({}, base), { backgroundColor: state.isSelected ? '#E3E3E3' : 'white', color: 'black', '&:hover': {
                        backgroundColor: '#E3E3E3',
                    } }));
            },
            menu: function (base) { return (__assign(__assign({}, base), { marginTop: '0px', borderBottomRightRadius: '8px', borderBottomLeftRadius: '8px', borderTopRightRadius: '0px', borderTopLeftRadius: '0px', border: '1px solid #E3E3E3', borderTopWidth: 0 })); },
            menuList: function (base) { return (__assign(__assign({}, base), { color: 'black', padding: '0px', borderBottomRightRadius: '8px', borderBottomLeftRadius: '8px' })); },
            singleValue: function (base) { return (__assign(__assign({}, base), { color: 'black' })); },
        }, defaultValue: options[0], className: "SelectSystem", onChange: handleChange, options: options, isDisabled: data.length === 0 }));
};
export default SelectStatistics;
